import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-7c5b4672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full relative" }
const _hoisted_2 = { class: "absolute top-0 right-0 z-10" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row p-2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_0,
  alt: "close"
}, null, -1 /* HOISTED */))
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.mode !== $setup.MODES.instruction && $setup.mode !== $setup.MODES.instructionReview && $setup.mode !== $setup.MODES.placeReview && $setup.mode !== $setup.MODES.quizz)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ($setup.mode !== $setup.MODES.quizzIntro && $setup.mode !== $setup.MODES.finished)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.players, (p) => {
                  return (_openBlock(), _createBlock($setup["Avatar"], {
                    key: p._id,
                    layout: p.profile.avatar,
                    class: "w-24 h-24 -mr-6"
                  }, null, 8 /* PROPS */, ["layout"]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createVNode($setup["Button"], {
              class: "pointer-events-auto ml-6 bg-white m-6",
              childclass: 'w-12 h-12',
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.finish()))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_Transition, {
      mode: "out-in",
      name: "fade"
    }, {
      default: _withCtx(() => [
        ($setup.mode === $setup.MODES.intro)
          ? (_openBlock(), _createBlock($setup["Intro"], {
              key: 0,
              title: $setup.t('title'),
              description: $setup.t('description'),
              "exercise-index": $setup.exerciseIndex,
              image: $setup.introImage,
              "image-height": '14rem'
            }, {
              default: _withCtx(() => [
                _createVNode($setup["Button"], {
                  backgroundcolour: 'bg-sl-green-button',
                  textcolour: 'text-white',
                  childclass: 'text-2xl border-none h-16 p-4 inline-block',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeMode($setup.MODES.playersReady)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "description", "exercise-index", "image"]))
          : ($setup.mode === $setup.MODES.playersReady)
            ? (_openBlock(), _createBlock($setup["PlayersReady"], {
                key: 1,
                description: $setup.t('yourTurn'),
                players: $setup.players
              }, {
                default: _withCtx(() => [
                  ($setup.alreadySeenInstruction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode($setup["Button"], {
                          backgroundcolour: 'bg-white',
                          textcolour: 'text-black',
                          childclass: 'text-2xl border-none h-16 w-56',
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeMode($setup.MODES.instruction)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('instructions')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode($setup["Button"], {
                          class: "ml-8",
                          backgroundcolour: 'bg-sl-green-button',
                          textcolour: 'text-white',
                          childclass: 'text-2xl border-none h-16 w-56',
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeMode($setup.MODES.quizz)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('spill')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]))
                    : (_openBlock(), _createBlock($setup["Button"], {
                        key: 1,
                        backgroundcolour: 'bg-sl-green-button',
                        textcolour: 'text-white',
                        childclass: 'text-2xl border-none h-16 w-56',
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeMode($setup.MODES.instruction)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["description", "players"]))
            : ($setup.mode === $setup.MODES.instruction)
              ? (_openBlock(), _createBlock($setup["Carousel"], {
                  key: 2,
                  class: "h-full"
                }, {
                  addons: _withCtx(() => [
                    _createVNode($setup["CarouselTrigger"], {
                      ref: "carouselTriggerRef",
                      onNewPage: _cache[6] || (_cache[6] = 
                (index) => {
                  $setup.bounce++
                  $setup.stopSounds()
                  $setup.playSounds([$setup.instructionPages[index].audio])
                }
              )
                    }, null, 512 /* NEED_PATCH */)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.instructionPages, (page, index) => {
                      return (_openBlock(), _createBlock($setup["Slide"], {
                        key: `page-${index}`,
                        index: index
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(page.component), {
                            ref_for: true,
                            ref: "instructionComponentTemplateRef",
                            question: $setup.question,
                            sentencelist: [],
                            bounce: $setup.bounce,
                            discussion: 'snakkeSammen',
                            description: page.description,
                            onChangemode: $setup.changeMode,
                            onPlaysound: ($event: any) => ($setup.playInstructionSound(index))
                          }, {
                            pagination: _withCtx(() => [
                              _createVNode($setup["Pagination"], { class: "my-12" })
                            ]),
                            default: _withCtx(() => [
                              (index + 1 === $setup.instructionPages.length)
                                ? (_openBlock(), _createBlock($setup["Button"], {
                                    key: 0,
                                    backgroundcolour: 'bg-sl-green-button',
                                    textcolour: 'text-white',
                                    childclass: 'text-2xl border-none h-16 w-56',
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changeMode($setup.MODES.quizz)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('start')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1064 /* PROPS, HYDRATE_EVENTS, DYNAMIC_SLOTS */, ["question", "bounce", "description", "onPlaysound"]))
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }))
              : ($setup.mode === $setup.MODES.placeReview)
                ? (_openBlock(), _createBlock($setup["FindPlaces"], {
                    key: 3,
                    onPlaysound: _cache[8] || (_cache[8] = 
          () => {
            $setup.stopSounds()
            $setup.playSounds([$setup.instructionPages[0].audio])
          }
        )
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["Button"], {
                        backgroundcolour: 'bg-sl-green-button',
                        textcolour: 'text-white',
                        childclass: 'text-2xl border-none px-5 py-2',
                        onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.changeMode($setup.MODES.quizz)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.savedState ? $setup.t('back') : $setup.t('next')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }))
                : ($setup.mode === $setup.MODES.instructionReview)
                  ? (_openBlock(), _createBlock($setup["HorerQuizz"], {
                      key: 4,
                      sentencelist: [],
                      question: $setup.question,
                      bounce: $setup.bounce,
                      onDone: _cache[10] || (_cache[10] = ($event: any) => ($setup.changeMode($setup.MODES.quizz))),
                      onPlaysound: _cache[11] || (_cache[11] = 
          () => {
            $setup.stopSounds()
            $setup.playSounds([$setup.instructionPages[1].audio])
          }
        )
                    }, {
                      default: _withCtx(() => [
                        _createVNode($setup["Button"], {
                          backgroundcolour: 'bg-sl-green-button',
                          textcolour: 'text-white',
                          childclass: 'text-2xl border-none px-5 py-2',
                          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.changeMode($setup.MODES.quizz)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.savedState ? $setup.t('back') : $setup.t('next')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["question", "bounce"]))
                  : ($setup.mode === $setup.MODES.quizz)
                    ? (_openBlock(), _createBlock($setup["HorerQuizz"], {
                        key: 5,
                        sentencelist: $setup.question.sentencelist,
                        question: $setup.question,
                        round: $setup.savedRound,
                        bounce: $setup.bounce,
                        onFinish: _cache[12] || (_cache[12] = ($event: any) => ($setup.finish())),
                        onReplay: _cache[13] || (_cache[13] = ($event: any) => ($setup.changeMode($setup.MODES.playersReady))),
                        onDone: _cache[14] || (_cache[14] = ($event: any) => ($setup.changeMode($setup.MODES.finished))),
                        onReview: $setup.reviewMode
                      }, null, 8 /* PROPS */, ["sentencelist", "question", "round", "bounce"]))
                    : ($setup.mode === $setup.MODES.finished)
                      ? (_openBlock(), _createBlock($setup["Intro"], {
                          key: 6,
                          title: $setup.t('titleFinished'),
                          description: $setup.t('descriptionFinished'),
                          image: $setup.youpiImage
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["Button"], {
                              backgroundcolour: 'bg-sl-green-button',
                              textcolour: 'text-white',
                              childclass: 'text-2xl border-none h-16 w-56',
                              onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.finish()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('done')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["title", "description", "image"]))
                      : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}